<template>
  <div>
    <div id="ConsultaDireccion_div">
      <div id="TituloConsultaDireccion_div" class="w-100 px-3">
        <h1>CONSULTA DE SALIDAS DEL DÍA</h1>
      </div>
       <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
        <div class="flex-grow-1 pl-3"><h4 style="color: #ffff;">Búsqueda y consulta de información cédulas de salidas</h4></div>
      </div>
      <div id="ContenidoConsultaDireccion_div" class="area container-fluid">
        <!-- <h3>Ingrese la informacion requerida para filtrar salidas</h3> -->
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
            <div class="">
              <FiltrosDeBusqueda 
                :elementosAConservar = "elementosAConservar"
                :elementosAOmitir = "elementosAOmitir"
                :posicionHorizontal="true"
                :conSwitchHabilitacion="true"
                :catalogos="catalogos" 
                :ejecutaLaFuncion="evtBuscarDeSalida" 
                :filtrosEstablecidos="filtrosEstablecidos" 
                :tituloDeBusqueda="'Paso 1: Busca las salidas'"
                v-on:cambioTipoDeCedula="evtCambioTipoCedula"
                v-on:cambioTipoNotificador="evtCambioTipoNotificador"
                v-on:cambioTipoZona="evtCambioTipoZona"
                v-on:AccionEnSwitchDeFiltros="evtAccionEnSwitchDeFiltros"
                :ref="REF_FB"></FiltrosDeBusqueda>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-3 pt-4">
            <div>
                <!-- <h5>Consulta la informacion</h5> -->
                <div id="PanelDeAudienciasPendientesPendientes_table">
                  <div v-show="!cargandoCedulasDeSalida">
                    <div style="padding: 8px;">
                      <div class="form-inline justify-content-start">
                        <i class="fas fa-clipboard-list mr-sm-2" style="font-size: 25px; color: black;"></i>
                        <div class="align-content-center">
                          <h3 style="margin: 0; color: black;">Listado cédulas de salidas</h3>
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div>
                        <div id="filtros-memoria-cedulas" class="form-inline mb-3 justify-content-end">
                          <div id="filtros-input-cedulas-memoria" class="f-item form-group mr-sm-2">
                            <h6 for="f-busqueda" class="mr-sm-2" style="color: black;">Buscar:</h6>
                            <input v-model="f_busqueda" type="text" id="f-busqueda" placeholder="Buscar en todas las columnas" class="form-control" style="width: 300px;"/>
                          </div>
                          <div class="f-item form-group">
                            <button type="button" id="btn-limpiar-filtro" @click="evtResetearFiltros" class="btn-sm btn-primary"><i class="fas fa-undo"></i></button>
                          </div>
                        </div>
                      <!--  <hr style="height:2px;border:none;color:#FFF;background-color:#fff; margin-top:1px;"/> -->
                        <TablaGenericaCedulas class="table-responsive"
                          :idDelInput="idTabla" 
                          :encabezadosColumnas="encabezadosColumnas" 
                          :accionesEnTabla="tablaAcciones" 
                          :listaDeCedulas="cedulasTablaConFiltros"
                          :conResponsive="true"
                          v-on:accionFuncionDetalles="obtenerCedulaSeleccionado"
                          :ref="REF_T_SALIDAS"></TablaGenericaCedulas>
                      </div>
                    </div>
                  </div>
                  <div v-if="cargandoCedulasDeSalida" class="contenedor-cargando" style="height: 300px ;">
                      <div class="text-center">
                          <i class="fas fa-spinner fa-spin fa-5x"></i>
                          <h4 class="mt-4">Cargando cédulas de salida</h4>
                      </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal align-middle visor-documento" tabindex="-1" data-backdrop="static" data-keyboard="false" id="descripcion-cedula-VCSDD">
          <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title"><i class="fas fa-info-circle"></i>&nbsp;Detalles</h5>
                      <button id="'btn-cerrar-descripcion-cedula-VCSDD" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                  </div>
                  <div class="modal-body">
                      <div style="padding: 1em 2em 0em 2em">
                        <CDescripcionBasicaDeCedula v-if="cedulaSeleccionada != null" class="" 
                          :idDelInput="'descripcionCedulaVCSDD'"
                          :cedula="cedulaSeleccionada"
                          :conVisualizadorDeDocumento="false"
                          :conSalidasYConstituciones="true"
                          :key="'DCVCSDD' + contRenderDC"></CDescripcionBasicaDeCedula>
                      </div>
                  </div>  
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import router from '@/router/index'
import VueMask from 'v-mask'
import { areasAFiltrarParaDireccion } from "../../Comun/Funciones/validaciones.js"

  Vue.use(VueMask);
  export default {
   components: {
      FiltrosDeBusqueda: sistemas.SINOJ.FiltrosDeBusqueda,
      TablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
      CDescripcionBasicaDeCedula: sistemas.SINOJ.CDescripcionBasicaDeCedula
    },
    data() {
      return {
        areasAFiltrarParaDireccion,
        elementosAConservar: {},
        elementosAOmitir: {},
        enumeraciones,
        FORMATO_FECHA: "DD/MM/YYYY HH:mm:ss",
        catalogos: [
          { catalogoId: 'filtroNumeroFolio', idDelInput: 'FNumFolioVCSDD'},
          { catalogoId: enumeraciones.catalogos.Fecha, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Fecha_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.sinoj.catalogos.Notificadores, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.sinoj.catalogos.Zonas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.sinoj.catalogos.TiposDeCedula, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_ConsultaSalidasDelDia' },
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'f-nExtra-ConsultaDireccion-ConsultaSalidasDelDia' }
        ],
        filtrosEstablecidos: {},
        idTabla: 'tablaSalidasVCS',
        REF_T_SALIDAS: 'REFtablaSalidasVCS',
        REF_FB: 'REFFiltrosBVCS',
        encabezadosColumnas: ['Folio', 'Fecha de registro', 'Estatus', 'Notificador', 'Resultado',''],
        tablaAcciones: { motrarAcciones: true, check: false, eliminar: false, detalles: true, ver: false},
        cedulasDeSalidasBD: [],
        cedulasDeSalidasTabla: [],
        cedulasTablaConFiltros: [],
        cargandoCedulasDeSalida: false,
        mesajeSinCedulas: 'No se ha realizado ninguna busqueda, en el paso 1 presione el botón de Buscar.',
        tipoCedulaId: -1,
        tipoNotificadorId: -1,
        tipoZonaId: -1,
        f_busqueda: '',
        cedulaSeleccionada: null,
        contRenderDC: 0,
        filtrosDeBusquedaSecciones: {
          expediente: true,
          cedula: true,
          fechas: true
        }
      }
    },
    methods: {
      evtAccionEnSwitchDeFiltros: function(accionRealizada) {
        switch(accionRealizada.tipoDeFiltro) {
            case 'Expediente':
                this.filtrosDeBusquedaSecciones.expediente = accionRealizada.habilitar;
                break;
            case 'Cedula':
                this.filtrosDeBusquedaSecciones.cedula = accionRealizada.habilitar;
                break;
            case 'Fechas':
                this.filtrosDeBusquedaSecciones.fechas = accionRealizada.habilitar;
                break;
            default:
                break;
        };
      },
      obtenerCedulaSeleccionado: function(evento) {
        this.cedulaSeleccionada = null;
        const CEDULA_SELECCIONADA = evento.target.getAttribute('id');
        const ID_CEDULA = parseInt(this.obtenerCedula(CEDULA_SELECCIONADA));
        this.cedulasDeSalidasBD.filter(sDB => sDB.Cedula.CedulaId == ID_CEDULA).forEach(s => {
            this.cedulaSeleccionada = s.Cedula;
        });
        this.contRenderDC ++;
        $('#descripcion-cedula-VCSDD').modal('show');
      },
      obtenerCedula: function(cedulaSeleccionada) {
        const CEDULA = cedulaSeleccionada.split('-');
        const POSICION_ID = (CEDULA.length - 1);
        const ID_CEDULA = CEDULA[POSICION_ID];
        return ID_CEDULA;
      },
      limpiarFiltrosDeTabla: function() {
        this.f_busqueda = null;
      },
      evtResetearFiltros: function() {
        this.limpiarFiltrosDeTabla();
        this.cedulasTablaConFiltros = this.cedulasDeSalidasTabla;
      },
      filtrarCedulasTabla: function(e) {
        // filtra por folio, estatus y resultado
        this.cedulasTablaConFiltros = this.cedulasDeSalidasTabla.filter(c => {
          return Object.values(c).some(valorColumna => this.predicateFiltradoPorSimilitud(valorColumna, this.f_busqueda));
        });
      },
      predicateFiltradoPorSimilitud: function(elementoAEvaluar,compararCon) { 
        if(this.campoRequeridoEsValido(compararCon)) {
          if(elementoAEvaluar.toString().toUpperCase().startsWith(compararCon.toString().toUpperCase()))
            return true;
          else
            return false;
        }
        else
            return true;
      },
      evtBuscarDeSalida: function () {
        this.mesajeSinCedulas = (this.mesajeSinCedulas != 'No se encontraron cedulas') ? 'No se encontraron cedulas' : this.mesajeSinCedulas;
        if(this.filtrosDeBusquedaSecciones.fechas) {
          if(this.campoRequeridoEsValido(this.$refs[this.REF_FB].fecha)) {
            this.limpiarFiltrosDeTabla();
            $("#filtros-input-cedulas-memoria input").off("change paste keyup");
            this.cedulasTablaConFiltros = [];
            this.cedulaSeleccionada = null;
            this.ObtenerCedulasDeSalidaBD();
          }
          else {
            comun.mensajeDeAlerta('Se detectaron campos incorrectos,<br>Debes seleccionar una fecha valida.');
          }
        }
        else {
          this.limpiarFiltrosDeTabla();
          $("#filtros-input-cedulas-memoria input").off("change paste keyup");
          this.cedulasTablaConFiltros = [];
          this.cedulaSeleccionada = null;
          this.ObtenerCedulasDeSalidaBD();
        }
      },
      ObtenerCedulasDeSalidaBD: function() { 
        const SERVIDOR = api.conexion;
        const METODO_API_OBTENER = api.SINOJ.sistema.consultas.salidasDelDia.ObtenerCedulasDeSalida;
        let urlApi = SERVIDOR + METODO_API_OBTENER;
        let peticionArchivos = false;
        let peticionAPI = {
            Folio: (this.campoRequeridoEsValido(this.$refs[this.REF_FB].numeroDeFolio) && this.filtrosDeBusquedaSecciones.cedula) ? this.$refs[this.REF_FB].numeroDeFolio : null,
            Fecha: this.campoRequeridoEsValido(this.$refs[this.REF_FB].fecha) && this.filtrosDeBusquedaSecciones.fechas ? this.$refs[this.REF_FB].fecha : null,
            PartidoJudicialId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_PartidoJudicial.partidoJudicialId : null,
            MateriaId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Materia.materiaId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_Materia.materiaId : null,
            JuzgadoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_Area.areaId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_Area.areaId : null,
            TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].parametros_TipoDocumento.tipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(parseInt(this.$refs[this.REF_FB].numeroExtra)) && this.filtrosDeBusquedaSecciones.expediente ? parseInt(this.$refs[this.REF_FB].numeroExtra) : null,
            NumeroDeDocumento: this.campoRequeridoEsValido(this.$refs[this.REF_FB].consecutivo) && this.filtrosDeBusquedaSecciones.expediente ? this.$refs[this.REF_FB].consecutivo : null,
            TipoDeCedulaId: this.campoRequeridoEsValido(this.tipoCedulaId) && this.filtrosDeBusquedaSecciones.cedula ? this.tipoCedulaId : null,
            ZonaId: this.campoRequeridoEsValido(this.tipoZonaId) && this.filtrosDeBusquedaSecciones.cedula ? this.tipoZonaId : null,
            NotificadorId: this.campoRequeridoEsValido(this.tipoNotificadorId) && this.filtrosDeBusquedaSecciones.cedula ? this.tipoNotificadorId : null,
            esPrueba: false
        }
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        this.cargandoCedulasDeSalida = true;
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                      //console.log('data::',respuesta.data.Salidas)
                        this.cedulasDeSalidasBD = (respuesta.data.Salidas != null) ? respuesta.data.Salidas : [];
                        this.cedulasDeSalidasTabla = this.darFormatoCedulasTabla(this.cedulasDeSalidasBD);
                        $("#filtros-input-cedulas-memoria input").on("change paste keyup", (e) => {
                            if(this.cedulasDeSalidasTabla.length > 0 && !this.cargandoCedulasDeSalida) {
                                this.filtrarCedulasTabla(e);
                            }
                        });
                        this.cedulasTablaConFiltros = this.cedulasDeSalidasTabla;
                    }
                    this.cargandoCedulasDeSalida = false;
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    this.cargandoCedulasDeSalida = false;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      darFormatoCedulasTabla: function(salidas) {
          let cedulasConFormato = [];
          salidas.forEach(s => {
            let cedulaFormatoTabla = this.cedulaAObjetoTabla(s.Cedula);
            cedulasConFormato.push(cedulaFormatoTabla);
          });
          return cedulasConFormato;
      },
      cedulaAObjetoTabla: function(cedula) {
        //'Folio', 'Fecha de registro', 'Estatus','Notificador', 'Resultado'
          let cedulaObjTabla = {};
          cedulaObjTabla.Folio = cedula.CedulaId;
          cedulaObjTabla.FechaRegistro = moment(cedula.FechaDeRegistro).format(this.FORMATO_FECHA);
          cedulaObjTabla.Estatus = cedula.Estatus.Nombre; // remplazar cuando este parte de acuerdos
          /* cedulaObjTabla.numeroSalidas = 0;
          cedulaObjTabla.numeroConstituciones = 0; */
          let { Notificador } = cedula;
          cedulaObjTabla.Notificador = this.obtenerNombreNotificador(Notificador);
          /* if(cedula.Salidas != null && cedula.Salidas.length > 0) {
              cedulaObjTabla.numeroSalidas = cedula.Salidas.length;
              let numeroDeContituciones = cedula.Salidas.filter(s => s.Constituciones != null).length;
              cedulaObjTabla.numeroConstituciones = numeroDeContituciones;
          } */
          cedulaObjTabla.Resultado = (cedula.Resultado != null) ? cedula.Resultado.TipoResultado.Nombre : 'Sin resultado';
          return cedulaObjTabla;
      },
      obtenerNombreNotificador: function(notificador) {
        let nombreCompleto = 'Sin notificador'
        if(notificador != null && notificador != undefined) {
          const { Usuario } = notificador;
          if(Usuario != null && Usuario != undefined) {
            const DATOS_DE_NOMBRE = [Usuario.Nombre, Usuario.ApellidoPaterno, Usuario.ApellidoMaterno];
            nombreCompleto = DATOS_DE_NOMBRE.join(' ');
          }
        }
        return nombreCompleto;
      },
      evtCambioTipoCedula: function(evento) {
        const TIPO_CEDULA_ID = parseInt(evento.target.value);
        this.tipoCedulaId = (TIPO_CEDULA_ID > 0) ? TIPO_CEDULA_ID : -1;
      },
      evtCambioTipoNotificador: function(evento) {
        const TIPO_NOTIFICADOR_ID = parseInt(evento.target.value);
        this.tipoNotificadorId = (TIPO_NOTIFICADOR_ID > 0) ? TIPO_NOTIFICADOR_ID : -1;
      },
      evtCambioTipoZona: function(evento) {
        const TIPO_ZONA_ID = parseInt(evento.target.value);
        this.tipoZonaId = (TIPO_ZONA_ID > 0) ? TIPO_ZONA_ID : -1;
        this.tipoNotificadorId = -1;
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      }   
    },
    mounted() { 
      this.evtBuscarDeSalida();      
    },
    created() {
      this.mesajeSinCedulas = 'No se ha realizado ninguna busqueda, en el paso 1 presione el boton de Buscar.';

      // Filtros de areas.
      let filtrosAreas = areasAFiltrarParaDireccion({ areaDireccion: this.$store.state.Login_Usuario.Area.AreaId, conDireccion: true });

      if(filtrosAreas.elementosAOmitir != undefined || filtrosAreas.elementosAOmitir != null)
        this.elementosAOmitir.areas = filtrosAreas.elementosAOmitir;
      
      if(filtrosAreas.elementosAConservar != undefined || filtrosAreas.elementosAConservar != null)
        this.elementosAConservar.areas = filtrosAreas.elementosAConservar;
    },
    watch: {
        cedulasDeSalidasTabla() {
            if(this.cedulasDeSalidasTabla.length > 0 && !this.cargandoCedulasDeSalida) {
                this.$refs[this.REF_T_SALIDAS].cedulasAmostrarPorPagina = 6;
            }
        },
    }
  }
</script>
<style scoped>
@media screen and (max-width: 650px) {
  #filtros-memoria-cedulas {
    flex-direction: column !important;
  }

  #filtros-input-cedulas-memoria {
    flex-direction: column !important;
    margin-bottom: 10px !important;
    margin-right: 0px !important;
  }

  #filtros-input-cedulas-memoria input {
    width: 100% !important;
  }

  .f-item {
    width: 100% !important;
  }

  #filtros-memoria-cedulas .btn-sm {
    width: 100% !important;
  } 
}

.visor-documento .modal-lg {
    max-width: 50% !important;
}

.modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#filtros-memoria-cedulas .btn-sm {
  cursor: pointer;
  background-color: rgb(27, 25, 25);
  padding: 5px 15px 5px 15px;
} 

#filtros-memoria-cedulas .btn-sm:hover, #filtros-memoria-cedulas .btn-sm:focus {
  background-color: black;
}

#filtros-memoria-cedulas .form-control::-webkit-input-placeholder { color: rgb(201, 192, 192); }  /* WebKit, Blink, Edge */
#filtros-memoria-cedulas .form-control:-moz-placeholder { color:  rgb(201, 192, 192); }  /* Mozilla Firefox 4 to 18 */
#filtros-memoria-cedulas .form-control::-moz-placeholder { color:  rgb(201, 192, 192); }  /* Mozilla Firefox 19+ */
#filtros-memoria-cedulas .form-control:-ms-input-placeholder { color:  rgb(201, 192, 192); }  /* Internet Explorer 10-11 */
#filtros-memoria-cedulas .form-control::-ms-input-placeholder { color:  rgb(201, 192, 192); }  /* Microsoft Edge */

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

.contenedor-sin-cedula {
    background-color: rgb(36, 34, 34);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.contenedor-cargando {
    background-color: var(--gris-pj-100);
    height: 40px;
    height: 21rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

#encabezado-contenedor-contenido {
  background-color: var(--verde-pj);
  padding: 10px;
}

#ConsultaDireccion_div .area {
  background-color: var(--gris-pj-100);
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/SalidasDelDia/ConsultaSalidasDelDia.vue